import Bean from 'bean';
import CommonInterface from './commonInterface';
import deepFreeze from '../utilities/freeze';
export default class BaseComponent extends CommonInterface {
    /**
     *
     * constructor
     *
     * @param {Element} element
     */
    constructor(element) {
        super();
        this._componentElement = element;
        this._componentElement.setAttribute('data-component-init', 'true');
        this._checkMessages();
        //console.log(`%c[${this.COMPONENT_NAME}]%c initialized`, 'color:orange;', 'color:white;');
    }
    /**
     * @returns {ComponentElement}
     */
    get _el() {
        return this._componentElement;
    }
    get _options() {
        const compOptions = {};
        const options = Object.assign({}, this._el.dataset);
        const optionsEntires = Object.keys(options).filter((entry) => entry.includes('option'));
        optionsEntires.forEach((entry) => {
            const cleanEntry = BaseComponent.cleanOptionKey(entry);
            let optionValue;
            if (options[entry].includes('{') && options[entry].includes('}')) {
                optionValue = JSON.parse(options[entry].replace(/'/g, '"'));
            }
            else {
                optionValue = BaseComponent.convertType(options[entry]);
            }
            compOptions[cleanEntry] = optionValue;
        });
        return deepFreeze(compOptions);
    }
    get COMPONENT_NAME() {
        return this._el.getAttribute('data-component');
    }
    static convertType(option) {
        let optionReturn;
        switch (option) {
            case 'false':
                optionReturn = false;
                break;
            case 'true':
                optionReturn = true;
                break;
            case 'null':
                optionReturn = null;
                break;
            default:
                optionReturn = option;
                break;
        }
        return optionReturn;
    }
    static cleanOptionKey(key) {
        const str = key.replace('option', '');
        return `${str.charAt(0).toLocaleLowerCase()}${str.slice(1)}`;
    }
    /**
     *
     * $on
     *
     * @param {String} events
     * @param {Function} cb
     * @param {Element} [element = this._el]
     * @param {Array|String|Element} [elements = null]
     */
    $on(events, cb, element = this._el, elements = null) {
        if (!element || !events || !cb)
            return;
        if (!elements) {
            Bean.on(element, events, (e) => {
                if (e)
                    e.stopPropagation();
                cb(e);
            });
        }
        else {
            Bean.on(element, events, elements, (e) => {
                if (e)
                    e.stopPropagation();
                cb(e);
            });
        }
    }
    /**
     *
     * $one
     *
     * @param {String} events
     * @param {Function} cb
     * @param {Element} [element = this._el]
     */
    $one(events, cb, element = this._el) {
        Bean.one(element, events, cb);
    }
    /**
     *
     * $off
     *
     * @param {String} events
     * @param {Element} [element = this._el]
     */
    $off(events, element = this._el) {
        Bean.off(element, events);
    }
    /**
     *
     * $fire
     *
     * @param {String} events
     * @param {Element} [element = this._el]
     */
    $fire(events, element = this._el) {
        Bean.fire(element, events);
    }
    updateAriaAttributes(element) {
        const attributes = [...element.attributes]
            .filter((attr) => {
            return attr.nodeName.indexOf('has') === -1;
        })
            .filter((attr) => {
            return attr.nodeName.indexOf('aria') > -1 && (attr.nodeValue === 'true' || attr.nodeValue === 'false');
        })
            .map((attr) => {
            return attr.nodeName;
        });
        attributes.forEach((attr) => {
            element.setAttribute(attr, element.getAttribute(attr) === 'true' ? 'false' : 'true');
        });
    }
}
